import { HdhrSettingsSchema } from './schemas/settingsSchemas.js';
export const defaultHdhrSettings = HdhrSettingsSchema.parse({});
//# sourceMappingURL=HdhrSettings.js.map